import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleType } from './shared/models/class/auth/role-type.enum';
import { NavLink } from './shared/models/class/nav/nav-link';
import { AuthService } from './shared/services/auth/auth.service';
import { NavService } from './shared/services/nav/nav.service';
import { SubscriptionBaseComponent } from './shared/subscription-base/subscription-base-component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent extends SubscriptionBaseComponent implements OnInit {
  title = 'RamDam-Admin';
  showFiller = false;
  nav: NavLink[] = [];
  isLog: boolean = false;
  isSA:boolean=false;


  constructor(
    private navService: NavService,
    private authService: AuthService,
    public router: Router,
  ) {
    super()
  }

  ngOnInit(): void {
    this.isSA = this.authService.isAuthorized([RoleType.SA]);
    this.initComponent();
  }

  toggleDrawer(drawer: any, component: string) {
    if ((component === 'logout' && drawer.opened) || component === 'other') {
      drawer.toggle()
    }
  }

  private initComponent(): void {
    if(!this.isSA){
    this.nav = this.navService.navLinks

    }else{
      this.nav = this.navService.navLinksSA

    }

    if (this.authService.getDecodedToken()) {
      this.authService.isLog$.next(true)
    }

    this.initSub();

  }

  private initSub(): void {
    this.subscription
      .add(
        this.authService.isLog$.subscribe({
          next: isLog => {
            this.isLog = isLog ? true : false;
          }
        })
      )
  }

}
